/*
 * Copyright (c) 2026 Gabriele Bonora. Tutti i diritti riservati.
 *
 * Software proprietario. Nessuna licenza d'uso, copia, modifica o distribuzione
 * e' concessa in assenza di autorizzazione scritta del titolare dei diritti.
 * Vedere il file LICENSE nella radice del progetto.
 */
import apiClient from './client';

export const strumentiAPI = {
  // Tipi strumento
  list: async (params = {}) => {
    const { data } = await apiClient.get('/strumenti', { params });
    return data;
  },

  categorie: async () => {
    const { data } = await apiClient.get('/strumenti/categorie');
    return data;
  },

  detail: async (id) => {
    const { data } = await apiClient.get(`/strumenti/${id}`);
    return data;
  },

  create: async (strumento) => {
    const { data } = await apiClient.post('/strumenti', strumento);
    return data;
  },

  update: async (id, strumento) => {
    const { data } = await apiClient.put(`/strumenti/${id}`, strumento);
    return data;
  },

  toggleAttivo: async (id, attivo) => {
    const { data } = await apiClient.patch(`/strumenti/${id}/attivo`, { attivo });
    return data;
  },

  // Pezzi singoli
  addPezzo: async (tipoId, pezzo) => {
    const { data } = await apiClient.post(`/strumenti/${tipoId}/pezzi`, pezzo);
    return data;
  },

  updatePezzo: async (pezzoId, pezzo) => {
    const { data } = await apiClient.put(`/strumenti/pezzi/${pezzoId}`, pezzo);
    return data;
  },

  changeStatoPezzo: async (pezzoId, stato, assegnato_a = null) => {
    const { data } = await apiClient.patch(`/strumenti/pezzi/${pezzoId}/stato`, { stato, assegnato_a });
    return data;
  },

  deletePezzo: async (pezzoId) => {
    const { data } = await apiClient.delete(`/strumenti/pezzi/${pezzoId}`);
    return data;
  },
};
